import React, { useEffect, useRef, useState, useMemo } from "react";
import { APIProvider, Map } from "@vis.gl/react-google-maps";
import { useAdvSearch } from "../providers/advSearchCtx";
import { useQuery } from "@tanstack/react-query";
import Markers from "../components/Map/Markers";
import { getMarkers } from "../lib/utils";
import Legenda from "../components/Map/Legenda";
import { mapStyles } from "../lib/confs";
import debounce from "lodash/debounce";

function SearchMap() {
  const { centerCoords, setCenterCoords, params } = useAdvSearch();

  // Debounce centerCoords per non aggiornare subito la query
  // Puoi mantenere la tua versione o rifarla con lodash se vuoi

  const { data, error, isLoading } = useQuery({
    queryKey: [
      "markers",
      {
        bounds: centerCoords.bounds,
        ...params,
      },
    ],
    queryFn: () =>
      getMarkers({
        bounds: centerCoords.bounds,
        ...params,
      }),
    staleTime: 1000 * 60 * 5,
    retry: false,
  });

  const markers = data?.data.listings || [];

  // Creo la funzione debounced ONCE con useMemo
  const debouncedSetCenterCoords = useMemo(
    () =>
      debounce((bounds) => {
        setCenterCoords((prev) => ({
          ...prev,
          bounds: {
            ne: { lat: bounds.north, lng: bounds.east },
            sw: { lat: bounds.south, lng: bounds.west },
          },
        }));
      }, 500),
    [setCenterCoords],
  );

  const onBoundsChanged = (ev) => {
    const bounds = ev.detail.bounds;
    debouncedSetCenterCoords(bounds);
  };

  // Quando il componente si smonta cancella la funzione debounced per evitare memory leak
  useEffect(() => {
    return () => {
      debouncedSetCenterCoords.cancel();
    };
  }, [debouncedSetCenterCoords]);

  return (
    <div
      className="uk-position-relative"
      style={{ zIndex: 0, height: "800px" }}
    >
      <Legenda />
      <APIProvider
        apiKey={"AIzaSyDd8yzaUABJy0E8cPCuD4C7CU1_kQcK6GE"}
        onLoad={() => console.log("Maps API has loaded")}
      >
        <Map
          mapId="adv_search_map"
          style={{ height: "800px", width: "100%" }}
          styles={mapStyles}
          defaultCenter={centerCoords}
          defaultZoom={10}
          onLoad={(ev) => {
            console.log(ev);
          }}
          onBoundsChanged={onBoundsChanged}
        >
          {!isLoading && <Markers markers={markers} />}
        </Map>
      </APIProvider>
    </div>
  );
}

export default SearchMap;
